import * as React from 'react';

/* -------------------------------------------------------------------------------------------------
 * Well
 * -----------------------------------------------------------------------------------------------*/

type WellElement = React.ElementRef<'div'>;
type WellProps = Omit<React.ComponentPropsWithoutRef<'div'>, 'className'>;

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const Well = React.forwardRef<WellElement, WellProps>(
  (props, forwardedRef) => {
    return (
      <div
        {...props}
        className="border-grey-300 flex flex-col gap-6 rounded-xl border p-4 bg-white"
        ref={forwardedRef}
      />
    );
  },
);

Well.displayName = 'Well';
